
import { atom } from 'nanostores';
import type { UserRootDataType, UserPersonalDataType } from '../../types/user-types';

export const accessTokenStore = atom<string>('');

export const userRootDataStore = atom<UserRootDataType | undefined>(undefined);

export const userPersonalDataStore = atom<UserPersonalDataType | undefined>(undefined);